import { z } from 'zod';

declare const tableBrand: unique symbol;

/**
 * A row id. At runtime a plain string (uuid v7); the table name is only a type
 * brand, so an id of one table cannot be passed where another is expected.
 */
export type Id<T extends string> = string & { readonly [tableBrand]: T };

/** Validates a non-empty string and brands it for the named table. */
export function idSchema<T extends string>(_table: T) {
  return z.custom<Id<T>>(
    (value) => typeof value === 'string' && value.length > 0,
    { error: 'Expected an id.' },
  );
}
